
import { defineComponent, watch } from "vue";
import { useApolloClient } from "@vue/apollo-composable";
import gql from "graphql-tag";
import VDButton from "./VDButton.vue";
import useUserCatalogSettings from "@/composables/useUserCatalogSettings";
import { GetUserCatalogSettingsQuery } from "@/graphql/types";

const settingsQuery = gql`
  query GetUserCatalogSettings {
    userCatalogSettings {
      mfaEnabled
    }
  }
`;

export default defineComponent({
  components: { VDButton },
  setup() {
    const settings = useUserCatalogSettings();
    const { client } = useApolloClient();

    function loadSettings(retry = false) {
      return settings.load(async () => {
        const response = await client.query<GetUserCatalogSettingsQuery>({
          query: settingsQuery,
          fetchPolicy: "no-cache",
          errorPolicy: "none",
          context: { queryDeduplication: false },
        });
        const value = response.data?.userCatalogSettings?.mfaEnabled;
        if (typeof value !== "boolean")
          throw new Error("MFA settings unavailable");
        return value;
      }, retry);
    }

    watch(settings.sessionId, () => loadSettings(), { immediate: true });

    return {
      failed: settings.failed,
      status: settings.status,
      loadSettings,
    };
  },
});
